import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { RecoverForm } from "@/features/auth/components/RecoverForm";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

type TRecoverPageProps = {};

export const RecoverPage: FC<TRecoverPageProps> = () => {
  return (
    <Stack gap={6} alignItems="center">
      <LoginLogo />
      <Typography variant="head20Bold">パスワードの再発行</Typography>
      <Typography variant="body14" width={400} color={"#5A6063"}>
        登録されたメールアドレスまたはユーザーIDを入力してください。
      </Typography>
      <RecoverForm />
      {/* <Linkable href={"#"}>
        <Typography variant="body14" color="#1890FF">
          メールの再送信（ご案内メールが届かない場合）
        </Typography>
      </Linkable> */}
    </Stack>
  );
};
